module.exports = __webpack_public_path__ + "static/img/swiper3.04fa77a2.png";